import * as yup from "yup";

export const editUploadSchema = yup.object().shape({
  name: yup.string().required("An upload name is required (defaults to the file name)"),
});
